import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-clearance-failed',
  templateUrl: './clearance-failed.component.html',
  styleUrls: ['./clearance-failed.component.scss']
})
export class ClearanceFailedComponent {
  @Output() retry = new EventEmitter<void>();
  @Output() contactSupport = new EventEmitter<void>();
  @Output() nextModal = new EventEmitter<void>();

}